export default __webpack_public_path__ + "424f816367760e9613900a720519a75f.svg";